import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const EmailAddress = (props) => {
  const name = 'email_address';

  const {
    label,
    inputId,
    parameters,
    groupName,
    required,
    onChangeParameter,
    errorMessage,
    tooltip,
    children,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange}
      groupName={groupName}
      tooltip={tooltip}
      errorMessage={errorMessage}
      disabled={disabled}>
      {children}
    </TextComponent>
  );
};

EmailAddress.defaultProps = {
  inputId: 'email-address',
  tooltip: Spree.helpForParameters.email_address,
  label: Spree.translations.parameters.email_address,
  required: false,
};

export default EmailAddress;
